import { cx } from '@twind/core';
import { ChatVersion } from 'app/copied/constants/common';
import useWebchatVersion from 'app/hooks/useWebchatVersion';

export default function CloseIcon({ className }: { className?: string }) {
  const webchatVersion = useWebchatVersion();
  if (webchatVersion === ChatVersion.v4_1) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className={cx('ostro-close-icon', className)}
      >
        <path
          d="M12 4L4 12"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4 4L12 12"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cx('ostro-close-icon', className)}
      role="img"
      aria-label="Close Icon"
    >
      <path
        id="Vector"
        d="M0.448785 8L0 7.55122L3.55121 4L0 0.448785L0.448785 0L4 3.55121L7.55122 0L8 0.448785L4.44879 4L8 7.55122L7.55122 8L4 4.44878L0.448785 8Z"
      />
    </svg>
  );
}
